import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { later } from "@ember/runloop"
import { inject as service } from "@ember/service"
import type EmberStore from "cc-frontend/services/ember-store"

@tagName("")
export default class OutlineDetails extends Component {
  // args
  focusedItemId

  // state
  localFocusedItemId = null
  isUnit = false
  isLesson = false

  @service("ember-store") store!: EmberStore

  didReceiveAttrs() {
    later(() => {
      if (this.isDestroyed || this.isDestroying) return
      this.setProperties({
        localFocusedItemId: this.focusedItemId,
        isUnit: this.focusedItemId && this.focusedItemId.toString().length > 10,
        isLesson: this.focusedItemId && this.focusedItemId.toString().length === 10,
      })
    }, 30)
  }
}
